import React, {useRef} from "react";
import {Box, IconButton, InputAdornment, TextField} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import CircularProgress from "@mui/material/CircularProgress";

export interface LemmaSearchBarViewProps {
    lemma: string;
    onLemmaChange: (lemma: string) => void;
    onSearch: () => void;
    onReset: () => void;
    isSearching: boolean;
    isLocked: boolean;
}

export interface LemmaSearchBarViewHandle {
    focus: () => void;
}

const LemmaSearchBarView = React.forwardRef<LemmaSearchBarViewHandle, LemmaSearchBarViewProps>(
    ({lemma, onLemmaChange, onSearch, onReset, isSearching, isLocked}, ref) => {

        const inputRef = useRef<HTMLInputElement | null>(null);

        React.useImperativeHandle(ref, () => ({
            focus: () => inputRef.current?.focus(),
        }));

        return (
            <Box sx={{display: "flex", alignItems: "center", width: "100%"}}>
                <TextField
                    inputRef={inputRef}
                    variant="outlined"
                    fullWidth={true}
                    placeholder="Search a word..."
                    value={lemma}
                    size="small"
                    autoFocus={true}
                    onChange={(e) => onLemmaChange(e.target.value)}
                    onKeyDown={(e) => {
                        if (e.key === "Enter") {
                            onSearch();
                        }
                    }}
                    InputProps={{
                        readOnly: isLocked,
                        endAdornment: (
                            <InputAdornment position="end">
                                {isSearching ? (
                                    <CircularProgress size={20}/>
                                ) : isLocked ? (
                                    <IconButton size="small" title="Reset" onClick={onReset}>
                                        <RestartAltIcon fontSize="small"/>
                                    </IconButton>
                                ) : (
                                    <IconButton size="small" title="Search" onClick={onSearch} disabled={!lemma.trim()}>
                                        <SearchIcon fontSize="small"/>
                                    </IconButton>
                                )}
                            </InputAdornment>
                        ),
                    }}
                />
            </Box>
        );
    }
);

export default LemmaSearchBarView;
